import React from 'react'

import { Box, Button, Typography } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';

import FormRow from 'components/form/FormRow';
import TextInput from 'components/form/input/TextInput';
import { useFieldValue } from 'components/form/input/NestedField'

import { fetchArray } from 'entity'
import Inscricao from 'entity/Inscricao'

import useNotification from 'notification'

function CardMesa({ nomeList, deleteMesa, index }) {
    let preField = nomeList + "." + index + "."

    return (
        <FormRow
            sx={{
                justifyContent: "center",
                mb: 1,
                p: 1,
                backgroundColor: "rgba(125,125,125,0.2)",
            }}
        >
            <TextInput
                name={preField + "name"}
                disabled
            />
        </FormRow>
    )
}

function TabelaMesas({ nome, rotulo, ...props }) {
    const [mesasAdicionadas, setMesasAdicionadas] = useFieldValue(nome)
    const { showError } = useNotification()

    let ancoras = []

    const newMesa = () => {
        let uidMesa = Math.random().toString(36).substring(7)
        let newName = `Mesa ${String(mesasAdicionadas?.length + 1).padStart(2, '0')}`


        setMesasAdicionadas([...mesasAdicionadas, { uid: uidMesa, name: newName }])
    }

    const deleteMesaStack = async () => {
        if (ancoras.length === 0) {
            let query = await Inscricao.query()
            query = query.where("status", "==", "INSCRITO")
            query = query.where("tipo", "==", "ÂNCORA")
            let result = await fetchArray(query.get())
            ancoras = result
        }

        ancoras.filter(a => {
            if (a.mesa
                && mesasAdicionadas[mesasAdicionadas.length - 1]
                && a.mesa.uid === mesasAdicionadas[mesasAdicionadas.length - 1].uid
            ) {
                return true
            } else {
                return false
            }
        })

        if (ancoras.filter(a => a.mesa && mesasAdicionadas[mesasAdicionadas.length - 1] && a.mesa.uid === mesasAdicionadas[mesasAdicionadas.length - 1].uid).length === 0) {
            let array = [...mesasAdicionadas]
            array.splice(mesasAdicionadas.length - 1, 1)
            setMesasAdicionadas(array)
        } else {
            showError(`MESA ${mesasAdicionadas.length} com Âncora`)
        }
    }

    return (
        <Box sx={{ display: "flex", flexBasis: "100%", flexDirection: "column" }}>
            <FormRow
                sx={{
                    display: "flex",
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    flexWrap: 'nowrap'
                }}
            >
                <Typography variant="h6">{rotulo}</Typography>
                <div>

                    <Button
                        onClick={newMesa}
                        style={{ margin: 20, alignSelf: 'flex-end' }}
                        startIcon={<AddIcon />}
                    >
                        Nova Mesa
                    </Button>
                </div>
            </FormRow>
            {mesasAdicionadas.length !== 0
                ? mesasAdicionadas.map((mesa, index) => (
                    <CardMesa
                        key={index}
                        index={index}
                        nomeList={nome}
                    />
                ))
                : <FormRow sx={{ display: "flex", justifyContent: 'center' }}>
                    {props.alerta ? props.alerta : <></>}
                    <Typography sx={{ color: 'text.disabled' }}>- NENHUMA MESA ADICIONADA -</Typography>
                </FormRow>
            }
            {mesasAdicionadas.length ? <Button
                onClick={deleteMesaStack}
                style={{ margin: 20, alignSelf: 'flex-end' }}
                startIcon={<DeleteIcon />}
            >
                Deletar Mesa
            </Button> : ""}
        </Box>
    )
}

export default TabelaMesas